import http from 'Arch/services/HttpService';

class CrudRequest {
  static baseUrl() {
    throw Error('Method baseUrl not implemented');
  }

  static url() {
    return this.baseUrl();
  }

  static list(queryParams = {}) {
    return http.get(this.baseUrl(), {
      params: queryParams,
    });
  }

  static save(payload) {
    return http.post(this.baseUrl(), payload);
  }

  static edit(id, payload) {
    return http.put(`${this.baseUrl()}/${id}`, payload);
  }

  static get(id) {
    return http.get(`${this.baseUrl()}/${id}`);
  }

  static remove(id) {
    return http.delete(`${this.baseUrl()}/${id}`);
  }

  static terminateCsv(params = {}) {
    return http.get(`${this.baseUrl()}/report-excel`, {
      responseType: 'blob',
      params,
    });
  }

  static makeFormDataRequest(
    url, payload = {}, {
      service = http,
      method = 'post',
      params = {},
    } = {},
  ) {
    const bodyForm = new FormData();

    Object.keys(payload)
      .forEach((key) => {
        const item = payload[key];

        if (typeof item === 'function') {
          const res = item(key, bodyForm);
          if (Array.isArray(res)) {
            bodyForm.append(...res);
          }
        } else {
          bodyForm.append(key, item);
        }
      });

    return service.request({
      url,
      method: String(method).toUpperCase(),
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: bodyForm,
      params,
    });
  }

  static makeRequest(url, method, ...rest) {
    return http[method](url, ...rest);
  }
}

export default CrudRequest;
